// Shared date formatting utilities

/**
 * Format a date string to a readable format
 * @param {string} dateStr - Date string to format
 * @param {Object} opts - Optional locale date options
 * @returns {string|null} Formatted date or null if invalid
 */
export function formatDate(dateStr, opts) {
  if (!dateStr) return null;
  try {
    const d = new Date(dateStr);
    const defaultOpts = { month: 'short', day: '2-digit', year: 'numeric' };
    return d.toLocaleDateString(undefined, opts || defaultOpts);
  } catch (e) {
    return null;
  }
}

/**
 * Format a date and time string to a readable format
 * @param {string} dateStr - Date string to format
 * @param {string} timeStr - Time string to append (optional)
 * @param {Object} opts - Optional locale date options
 * @returns {string|null} Formatted date/time or null if invalid
 */
export function formatDateTime(dateStr, timeStr, opts) {
  if (!dateStr) return null;
  try {
    const d = new Date(dateStr);
    const defaultOpts = { month: 'short', day: '2-digit', year: 'numeric' };
    const dateFormatted = d.toLocaleDateString(undefined, opts || defaultOpts);
    return timeStr ? `${dateFormatted} at ${timeStr}` : dateFormatted;
  } catch (e) {
    return null;
  }
}

/**
 * Get the CSS class for a doctor_assessment badge
 * @param {string} assessment - The assessment string
 * @returns {string} CSS class name
 */
export function getAssessmentBadgeClass(assessment) {
  if (assessment === 'High Risk') return 'badge-danger';
  if (assessment === 'Moderate Risk') return 'badge-warning';
  return 'badge-success';
}
